<template>
  <div class="dal-slider-content">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'DalSliderContent'
}
</script>

<style lang="scss" scoped>
.dal-slider-content {
  line-height: 1.175;
  font-size: 18px;
  text-align: left;
  margin: 0 auto;
  color: white;

  p {
    margin: 1em auto;

    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dal/DalSliderContent.vue